import { useAuth } from "@/hooks/useAuth";
import { createContext, useContext, ReactNode } from "react";

interface AuthContextProps {
  isAuthenticated: boolean;
  login: (email: string, password: string) => Promise<any>;
  logout: () => Promise<any>;
  accessToken: string | null;
}

const AuthContext = createContext<AuthContextProps | undefined>(undefined);

export const AuthProvider = ({ children }: { children: ReactNode }) => {
  const { accessToken, login, logout } = useAuth();

  const isAuthenticated = Boolean(accessToken); // Check if user is authenticated

  return (
    <AuthContext.Provider
      value={{ isAuthenticated, login, logout, accessToken }}
    >
      {children}
    </AuthContext.Provider>
  );
};

// Custom hook to use the AuthContext
export const useAuthContext = (): AuthContextProps => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error("useAuthContext must be used within an AuthProvider");
  }
  return context;
};
